module.exports = __webpack_public_path__ + "assets/img/tit2.0151f372.png";